export default "__VITE_ASSET__CllRYVKi__"